<template>
  <g>
    <path :d="'M' + A.x + ' ' + A.y + ' L' + B.x + ' ' + B.y + ' L' + C.x + ' ' + C.y + ' L' + D.x + ' ' + D.y + ' L' + E.x + ' ' + E.y + ' L' + F.x + ' ' + F.y + 'Z'" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
    <g v-for="side in sides" :key="'side-' + side.id">
      <g v-if="side.rand === saum">
        <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
        <g v-if="side.rand.oesenArt != inactiveOesen">
          <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
        </g>
      </g>
      <path v-if="side.rand === hohlsaum" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
    </g>
    <g v-for="(side, index) in sides" :key="index">
      <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#353535" stroke-width="1"/>
      <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#353535" stroke-width="1" fill="#353535"/>
      <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#353535" stroke-width="1" fill="#353535"/>
    </g>
    <text v-for="side in sides" :key="'label-' + side.id" :x="side.labelSpace.x" :y="side.labelSpace.y" font-weight="bold" font-family="sans-serif" font-size="2.5em" fill="#232323">{{side.name}}</text>
  </g>
</template>

<script>
import DataRand from './../../../../../data/main/config/setup/rand/randArt'

export default {
  props: ['material', 'rand'],
  data () {
    return {
      A: {
        x: 425 - 175 * this.sinCalc(30) - 175,
        y: 250 + 175 * this.sinCalc(60)
      },
      B: {
        x: 75,
        y: 250
      },
      C: {
        x: 75 + 175 * this.sinCalc(30),
        y: 250 - 175 * this.sinCalc(60)
      },
      D: {
        x: 75 + 175 * this.sinCalc(30) + 175,
        y: 250 - 175 * this.sinCalc(60)
      },
      E: {
        x: 425,
        y: 250
      },
      F: {
        x: 425 - 175 * this.sinCalc(30),
        y: 250 + 175 * this.sinCalc(60)
      },
      saum: DataRand.randArt.saum.titleSaum.name,
      hohlsaum: DataRand.randArt.hohlsaum.title.name,
      inactiveOesen: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt
    }
  },
  methods: {
    sinCalc (alpha) {
      return Math.sin(alpha * Math.PI / 180)
    }
  },
  computed: {
    sides () {
      return {
        a: {
          name: 'a',
          rand: this.rand.a.type,
          oesenAnzahl: this.rand.a.type === this.saum ? this.rand.a.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.A.x + 15 * this.sinCalc(30) / this.sinCalc(60),
            xEnd: this.F.x - 15 * this.sinCalc(30) / this.sinCalc(60),
            yConst: this.A.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return this.yConst
            }
          },
          saum: 'M' + (this.A.x - 30 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.A.y - 30) + ' L' + (this.F.x + 30 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.F.y - 30),
          hohlsaum: 'M' + (this.A.x - 9 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.A.y - 9) + ' L' + (this.F.x + 9 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.F.y - 9),
          labelSpace: {
            x: 245,
            y: 455
          },
          border: {
            line: {
              xStart: this.A.x,
              yStart: this.A.y + 20,
              xEnd: this.F.x,
              yEnd: this.F.y + 20
            },
            corner: {
              start: this.A.x + ',' + (this.A.y + 20) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 15) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 25),
              rotateStart: 'rotate(0, ' + this.A.x + ', ' + (this.A.y + 20) + ')',
              end: this.F.x + ',' + (this.F.y + 20) + ' ' + (this.F.x - 10) + ',' + (this.F.y + 15) + ' ' + (this.F.x - 10) + ',' + (this.F.y + 25),
              rotateEnd: 'rotate(0, ' + this.F.x + ', ' + (this.F.y + 20) + ')'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          rand: this.rand.b.type,
          oesenAnzahl: this.rand.b.type === this.saum ? this.rand.b.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.A.x + 15 * this.sinCalc(30) / this.sinCalc(60),
            xEnd: this.B.x + 15 / this.sinCalc(60),
            yStart: this.A.y - 15,
            yEnd: this.B.y,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.A.x + 30 / this.sinCalc(60)) + ' ' + this.A.y + ' L' + (this.B.x + this.sinCalc(30) * 30 / this.sinCalc(60)) + ' ' + (this.B.y - 30),
          hohlsaum: 'M' + (this.A.x + 9 / this.sinCalc(60)) + ' ' + this.A.y + ' L' + (this.B.x + this.sinCalc(30) * 9 / this.sinCalc(60)) + ' ' + (this.B.y - 9),
          labelSpace: {
            x: 70,
            y: 360
          },
          border: {
            line: {
              xStart: this.A.x - this.sinCalc(60) * 20,
              yStart: this.A.y + this.sinCalc(30) * 20,
              xEnd: this.B.x - this.sinCalc(60) * 20,
              yEnd: this.B.y + this.sinCalc(30) * 20
            },
            corner: {
              start: (this.A.x - this.sinCalc(60) * 20) + ',' + (this.A.y + this.sinCalc(30) * 20) + ' ' + (this.A.x - this.sinCalc(60) * 20 - 5) + ',' + (this.A.y + this.sinCalc(30) * 20 - 10) + ' ' + (this.A.x - this.sinCalc(60) * 20 + 5) + ',' + (this.A.y + this.sinCalc(30) * 20 - 10),
              rotateStart: 'rotate(-30, ' + (this.A.x - this.sinCalc(60) * 20) + ', ' + (this.A.y + this.sinCalc(30) * 20) + ')',
              end: (this.B.x - this.sinCalc(60) * 20) + ',' + (this.B.y + this.sinCalc(30) * 20) + ' ' + (this.B.x - this.sinCalc(60) * 20 - 5) + ',' + (this.B.y + this.sinCalc(30) * 20 + 10) + ' ' + (this.B.x - this.sinCalc(60) * 20 + 5) + ',' + (this.B.y + this.sinCalc(30) * 20 + 10),
              rotateEnd: 'rotate(-30, ' + (this.B.x - this.sinCalc(60) * 20) + ', ' + (this.B.y + this.sinCalc(30) * 20) + ')'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          rand: this.rand.c.type,
          oesenAnzahl: this.rand.c.type === this.saum ? this.rand.c.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.B.x + 15 / this.sinCalc(60),
            xEnd: this.C.x + 15 / this.sinCalc(60) * this.sinCalc(30),
            yStart: this.B.y,
            yEnd: this.C.y + 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.B.x + this.sinCalc(30) * 30 / this.sinCalc(60)) + ' ' + (this.B.y + 30) + ' L' + (this.C.x + 30 / this.sinCalc(60)) + ' ' + this.C.y,
          hohlsaum: 'M' + (this.B.x + this.sinCalc(30) * 9 / this.sinCalc(60)) + ' ' + (this.B.y + 9) + ' L' + (this.C.x + 9 / this.sinCalc(60)) + ' ' + this.C.y,
          labelSpace: {
            x: 70,
            y: 160
          },
          border: {
            line: {
              xStart: this.B.x - this.sinCalc(60) * 20,
              yStart: this.B.y - this.sinCalc(30) * 20,
              xEnd: this.C.x - this.sinCalc(60) * 20,
              yEnd: this.C.y - this.sinCalc(30) * 20
            },
            corner: {
              start: (this.B.x - this.sinCalc(60) * 20) + ',' + (this.B.y - this.sinCalc(30) * 20) + ' ' + (this.B.x - this.sinCalc(60) * 20 - 5) + ',' + (this.B.y - this.sinCalc(30) * 20 - 10) + ' ' + (this.B.x - this.sinCalc(60) * 20 + 5) + ',' + (this.B.y - this.sinCalc(30) * 20 - 10),
              rotateStart: 'rotate(30, ' + (this.B.x - this.sinCalc(60) * 20) + ', ' + (this.B.y - this.sinCalc(30) * 20) + ')',
              end: (this.C.x - this.sinCalc(60) * 20) + ',' + (this.C.y - this.sinCalc(30) * 20) + ' ' + (this.C.x - this.sinCalc(60) * 20 - 5) + ',' + (this.C.y - this.sinCalc(30) * 20 + 10) + ' ' + (this.C.x - this.sinCalc(60) * 20 + 5) + ',' + (this.C.y - this.sinCalc(30) * 20 + 10),
              rotateEnd: 'rotate(30, ' + (this.C.x - this.sinCalc(60) * 20) + ', ' + (this.C.y - this.sinCalc(30) * 20) + ')'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          rand: this.rand.d.type,
          oesenAnzahl: this.rand.d.type === this.saum ? this.rand.d.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.C.x + 15 * this.sinCalc(30) / this.sinCalc(60),
            xEnd: this.D.x - 15 * this.sinCalc(30) / this.sinCalc(60),
            yConst: this.C.y + 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return this.yConst
            }
          },
          saum: 'M' + (this.C.x - 30 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.C.y + 30) + ' L' + (this.D.x + 30 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.D.y + 30),
          hohlsaum: 'M' + (this.C.x - 9 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.C.y + 9) + ' L' + (this.D.x + 9 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.D.y + 9),
          labelSpace: {
            x: 245,
            y: 60
          },
          border: {
            line: {
              xStart: this.C.x,
              yStart: this.C.y - 20,
              xEnd: this.D.x,
              yEnd: this.D.y - 20
            },
            corner: {
              start: this.C.x + ',' + (this.C.y - 20) + ' ' + (this.C.x + 10) + ',' + (this.C.y - 15) + ' ' + (this.C.x + 10) + ',' + (this.C.y - 25),
              rotateStart: 'rotate(0, ' + this.C.x + ', ' + (this.C.y - 20) + ')',
              end: this.D.x + ',' + (this.D.y - 20) + ' ' + (this.D.x - 10) + ',' + (this.D.y - 15) + ' ' + (this.D.x - 10) + ',' + (this.D.y - 25),
              rotateEnd: 'rotate(0, ' + this.D.x + ', ' + (this.D.y - 20) + ')'
            }
          },
          id: 4
        },
        e: {
          name: 'e',
          rand: this.rand.e.type,
          oesenAnzahl: this.rand.e.type === this.saum ? this.rand.e.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.D.x - 15 / this.sinCalc(60) * this.sinCalc(30),
            xEnd: this.E.x - 15 / this.sinCalc(60),
            yStart: this.D.y + 15,
            yEnd: this.E.y,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.D.x - 30 / this.sinCalc(60)) + ' ' + this.D.y + ' L' + (this.E.x - this.sinCalc(30) * 30 / this.sinCalc(60)) + ' ' + (this.E.y + 30),
          hohlsaum: 'M' + (this.D.x - 9 / this.sinCalc(60)) + ' ' + this.D.y + ' L' + (this.E.x - this.sinCalc(30) * 9 / this.sinCalc(60)) + ' ' + (this.E.y + 9),
          labelSpace: {
            x: 410,
            y: 160
          },
          border: {
            line: {
              xStart: this.E.x + this.sinCalc(60) * 20,
              yStart: this.E.y - this.sinCalc(30) * 20,
              xEnd: this.D.x + this.sinCalc(60) * 20,
              yEnd: this.D.y - this.sinCalc(30) * 20
            },
            corner: {
              start: (this.E.x + this.sinCalc(60) * 20) + ',' + (this.E.y - this.sinCalc(30) * 20) + ' ' + (this.E.x + this.sinCalc(60) * 20 - 5) + ',' + (this.E.y - this.sinCalc(30) * 20 - 10) + ' ' + (this.E.x + this.sinCalc(60) * 20 + 5) + ',' + (this.E.y - this.sinCalc(30) * 20 - 10),
              rotateStart: 'rotate(-30, ' + (this.E.x + this.sinCalc(60) * 20) + ', ' + (this.E.y - this.sinCalc(30) * 20) + ')',
              end: (this.D.x + this.sinCalc(60) * 20) + ',' + (this.D.y - this.sinCalc(30) * 20) + ' ' + (this.D.x + this.sinCalc(60) * 20 - 5) + ',' + (this.D.y - this.sinCalc(30) * 20 + 10) + ' ' + (this.D.x + this.sinCalc(60) * 20 + 5) + ',' + (this.D.y - this.sinCalc(30) * 20 + 10),
              rotateEnd: 'rotate(-30, ' + (this.D.x + this.sinCalc(60) * 20) + ', ' + (this.D.y - this.sinCalc(30) * 20) + ')'
            }
          },
          id: 5
        },
        f: {
          name: 'f',
          rand: this.rand.f.type,
          oesenAnzahl: this.rand.f.type === this.saum ? this.rand.f.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.F.x - 15 * this.sinCalc(30) / this.sinCalc(60),
            xEnd: this.E.x - 15 / this.sinCalc(60),
            yStart: this.F.y - 15,
            yEnd: this.E.y,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.F.x - 30 / this.sinCalc(60)) + ' ' + this.F.y + ' L' + (this.E.x - this.sinCalc(30) * 30 / this.sinCalc(60)) + ' ' + (this.E.y - 30),
          hohlsaum: 'M' + (this.F.x - 9 / this.sinCalc(60)) + ' ' + this.F.y + ' L' + (this.E.x - this.sinCalc(30) * 9 / this.sinCalc(60)) + ' ' + (this.E.y - 9),
          labelSpace: {
            x: 412,
            y: 360
          },
          border: {
            line: {
              xStart: this.F.x + this.sinCalc(60) * 20,
              yStart: this.F.y + this.sinCalc(30) * 20,
              xEnd: this.E.x + this.sinCalc(60) * 20,
              yEnd: this.E.y + this.sinCalc(30) * 20
            },
            corner: {
              start: (this.F.x + this.sinCalc(60) * 20) + ',' + (this.F.y + this.sinCalc(30) * 20) + ' ' + (this.F.x + this.sinCalc(60) * 20 - 5) + ',' + (this.F.y + this.sinCalc(30) * 20 - 10) + ' ' + (this.F.x + this.sinCalc(60) * 20 + 5) + ',' + (this.F.y + this.sinCalc(30) * 20 - 10),
              rotateStart: 'rotate(30, ' + (this.F.x + this.sinCalc(60) * 20) + ', ' + (this.F.y + this.sinCalc(30) * 20) + ')',
              end: (this.E.x + this.sinCalc(60) * 20) + ',' + (this.E.y + this.sinCalc(30) * 20) + ' ' + (this.E.x + this.sinCalc(60) * 20 - 5) + ',' + (this.E.y + this.sinCalc(30) * 20 + 10) + ' ' + (this.E.x + this.sinCalc(60) * 20 + 5) + ',' + (this.E.y + this.sinCalc(30) * 20 + 10),
              rotateEnd: 'rotate(30, ' + (this.E.x + this.sinCalc(60) * 20) + ', ' + (this.E.y + this.sinCalc(30) * 20) + ')'
            }
          },
          id: 6
        }
      }
    }
  }
}
</script>

<style>
</style>
